module.exports = __webpack_public_path__ + "img/maintenance-5.a78d86e9.png";